export interface PrizeItem {
  id: number;
  name: string;
  amount: number;
  color: string;
  icon: string;
}

export const mockPrizes: PrizeItem[] = [
  {
    id: 1,
    name: 'Small Cash',
    amount: 50,
    color: 'linear-gradient(135deg, #1a2c38 0%, #000b24 100%)',
    icon: '💵',
  },
  {
    id: 2,
    name: 'Bonus Round',
    amount: 100,
    color: 'linear-gradient(135deg, #00b3f5 0%, #0a4f72 100%)',
    icon: '💵',
  },
  {
    id: 3,
    name: 'Big Win',
    amount: 500,
    color: 'linear-gradient(135deg, #627eea 0%, #3e5399 100%)',
    icon: '💵',
  },
  {
    id: 5,
    name: 'Mega Jackpot',
    amount: 5000,
    color: 'linear-gradient(135deg, #d80f83 0%, #8c0c57 100%)',
    icon: '💵',
  },
  {
    id: 6,
    name: 'Free Spin',
    amount: 10,
    color: 'linear-gradient(135deg, #00e676 0%, #2a8039 100%)',
    icon: '💵',
  },
  {
    id: 7,
    name: 'Huge Cash',
    amount: 1000,
    color: 'linear-gradient(135deg, #1a2c38 0%, #000b24 100%)',
    icon: '💵',
  },
  {
    id: 8,
    name: 'Epic Drop',
    amount: 2500,
    color: 'linear-gradient(135deg, #00b3f5 0%, #0a4f72 100%)',
    icon: '💵',
  },
  {
    id: 9,
    name: 'Mega Jackpot',
    amount: 5000,
    color: 'linear-gradient(135deg, #d80f83 0%, #8c0c57 100%)',
    icon: '💵',
  },
];
